import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/accFund/nobuy_bg.png'


const _hoisted_1 = { class: "fund-container" }
const _hoisted_2 = { class: "collapse-container" }
const _hoisted_3 = { style: {"font-size":"15px"} }
const _hoisted_4 = { style: {"font-size":"21px","font-weight":"bold"} }
const _hoisted_5 = { style: {"font-size":"15px"} }
const _hoisted_6 = { style: {"font-size":"21px","color":"#e000a0","font-weight":"700"} }
const _hoisted_7 = { style: {"text-align":"center","margin":"4px 0px","font-size":"12px"} }
const _hoisted_8 = { class: "table-container" }

import { ref } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
// import MainButton from '@/components/common/mainButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'accuFundView',
  setup(__props) {

// import CustomHeader from '@/components/common/customHeader.vue'
const activeName = ref('1');
const tableData = [
    { tempo: 'Day 1', montante: 'R$ 10', fluxo: '3 X' },
    { tempo: 'Day 2', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 3', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 4', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 5', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 6', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 7', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 8', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 9', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 10', montante: 'R$ 2', fluxo: '10 X' }
]
const investAmount = ref(10);
const resultAmount = ref(20);


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "topImg" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "secondTopImg" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_collapse, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
        accordion: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_collapse_item, { name: "1" }, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('accFund.invest')), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(investAmount.value), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('accFund.andGet')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(resultAmount.value), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('accFund.rewardPlan')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_row, {
                  class: "table-header",
                  type: "flex",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "8",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('accFund.time')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: "8",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('accFund.amountReceived')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_col, {
                      span: "8",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('accFund.gameFlow')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableData, (item, index) => {
                  return _createVNode(_component_van_row, {
                    class: _normalizeClass(['table-row', index % 2 !== 0 ? 'row-dark' : 'row-light', index === tableData.length - 1 ? 'last-row' : '']),
                    key: index,
                    type: "flex",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.tempo), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.montante), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, {
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.fluxo), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                }), 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_collapse_item, {
            title: "Title2",
            name: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('accFund.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})